import * as THREE from 'three'


 
  export const SalzschifffahrtLabels = [
    {
      Id: "Annotation_GmundenTraunPostkarte",
      Titel: "Gmunden Traun",
      TitelEn: "Gmunden Traun",
      Position: new THREE.Vector3(-787.153, 31.8506, 141.49),
      Rotation: new THREE.Vector3(0.0,0.0,-150),
      Scale: 1.5,
      isIFrame: false,
      iFrameUrl:
        "",
      offset: 0,
      offsetUp: -3,
      follow: false,
      lowModelCamZoom: 20
    },
    {
      Id: "Annotation_Kaiserschiff",
      Titel: "Kaiserschiff",
      TitelEn: "Emperor's ship",
      Position: new THREE.Vector3(-576.592, 7.11926, 64.4328),
      Rotation: new THREE.Vector3(0.0, 0.0,-30),
      Scale: 3,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/502e1d6045db4da2be732a8ea574cf53/embed",
      offset: 50,
      offsetUp: 30,
      follow: false,
      lowModelCamZoom: 15
    },
  
    {
      Id: "Annotation_Zille",
      Titel: "Zille",
      TitelEn: "Raft",
      Position: new THREE.Vector3(-605.031, 7.11926, 219.191),
      Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
      Scale: 2,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/ba3a5a3d9ede435a897f0f66497e93ae/embed",
      offset: -16,
      offsetUp: 20,
      follow: true,
      lowModelCamZoom: 15
    },

    {
        Id: "Annotation_Traunfall",
        Titel: "Traunfall",
        TitelEn: "The Traun waterfall",
        Position: new THREE.Vector3(-1039.24, 14.605, 133.497),
        Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
        Scale: 2,
        isIFrame: true,
        iFrameUrl:
          "",
        offset: 0,
        offsetUp: 25,
        follow: true,
        lowModelCamZoom: 15
      },

      {
        Id: "Annotation_Trauner",
        Titel: "Trauner",
        TitelEn: "Salzkammergut raft",
        Position: new THREE.Vector3(-850.909, 7.11926, -8.26436),
        Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
        Scale: 2,
        isIFrame: true,
        iFrameUrl:
          "https://sketchfab.com/models/f49c173322b84e67a16a52c0a6c01528/embed",
        offset: -16,
        offsetUp: 20,
        lowModelCamZoom: 15
      },

      {
        Id: "Annotation_Floss",
        Titel: "Holzflößer",
        TitelEn: "Raft made of wood",
        Position: new THREE.Vector3(-794.147, 14.605, -144.89),
        Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
        Scale: 2,
        isIFrame: true,
        iFrameUrl:
          "https://sketchfab.com/models/f5ca7d1448c64bd4a7e3ab3bde814e3d/embed",
        offset: -50,
        offsetUp: 14,
        follow: false,
        lowModelCamZoom: 15
      },
  ];


  export const SoleLeitungLabels = [
    {
      Id: "Annotation_GmundenSohleleitung",
      Titel: "Soleleitung",
      TitelEn: "Brine conduit",
      Position: new THREE.Vector3(-806.777, 14.2911, 198.013),
      Rotation: new THREE.Vector3(0.0, 0.0,0),
      Scale: 2,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/adc9cb76006b4b8b874c47045449830d/embed",
      offset: 0,
      offsetUp: 30,
      follow: true,
      lowModelCamZoom: 15
    },
  
    {
      Id: "Annotation_Salzkuefel",
      Titel: "Salzküfel",
      TitelEn: "Salt barrels",
      Position: new THREE.Vector3(-888.211, 4.71013, 480.106),
      Rotation: new THREE.Vector3(0.0, 0.0, -150),
      Scale: 1.5,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/eb79e7797a6545e7a98dfd4d2f8c6884/embed",
      offset: 0,
      offsetUp: 20,
      follow: false,
    
    },

    {
      Id: "Annotation_SalzkuefelTwo",
      Titel: "Salzküfel",
      TitelEn: "Salt barrels",
      Position: new THREE.Vector3(-919.785, 4.71012, 461.876),
      Rotation: new THREE.Vector3(0.0, 0.0, -150),
      Scale: 1.5,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/26f24dbea573456ebb107057d3c7a4cb/embed",
      offset: -10,
      offsetUp: 20,
      follow: false,
      lowModelCamZoom: 15
    },

    {
      Id: "Annotation_StadlPauraSalzkuefel",
      Titel: "Salzküfel",
      TitelEn: "Salt barrels",
      Position: new THREE.Vector3(-950.25, 4.71011, 430.287),
      Rotation: new THREE.Vector3(0.0, 0.0, -150),
      Scale: 1.5,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/d6936b48bf63438ab8066277901dcaed/embed",
      offset: -20,
      offsetUp: 20,
      follow: false,
      lowModelCamZoom: 15
    },

    {
        Id: "PicGalerie_Soleleitung",
        Titel: "Galerie Soleleitung",
        TitelEn: "The brine conduit gallery",
        Position: new THREE.Vector3(-913.266, 19.3686, 152.214),
        Rotation: new THREE.Vector3(0.0, 0.0, -60),
        Scale: 1.5,
        isIFrame: false,
        iFrameUrl:
          "",
        offset: 0,
        offsetUp: 0,
        follow: false
      },

      {
        Id: "PicGalerie_Kanaele",
        Titel: "Galerie Salzmärkte",
        TitelEn: "Gallery salt markets",
        Position: new THREE.Vector3(-997.05, 19.3686, 297.331),
        Rotation: new THREE.Vector3(0.0, 0.0, -60),
        Scale: 1.5,
        isIFrame: false,
        iFrameUrl:
          "",
        offset: 0,
        offsetUp: 0,
        follow: false
      },


  ];

  export const DieStaedteLabels = [
    {
      Id: "Annotation_Zunfttruhe",
      Titel: "Zunfttruhe",
      TitelEn: "Guild chest",
      Position: new THREE.Vector3(-49.7561, 0.200087, 546.933),
      Rotation: new THREE.Vector3(0.0, 0.0,30),
      Scale: 2,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/56a07d179049480092cf59a1b5904bcc/embed",
      offset: 0,
      offsetUp: 40,
      follow: false
    },
  
    {
      Id: "Annotation_Schiffskasse",
      Titel: "Schiffskasse",
      TitelEn: "Ship's cash box",
      Position: new THREE.Vector3(-38.034, 0.199998, 647.948),
      Rotation: new THREE.Vector3(0.0, 0.0, -150),
      Scale: 1.5,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/83304eec97774a99b36c90e1fffb26d7/embed",
      offset: 0,
      offsetUp: 30,
      follow: false,
      lowModelCamZoom: 18
    },

    {
      Id: "Annotation_KroneSalzamtleiter",
      Titel: "Die Totenkrone",
      TitelEn: "The crown of death",
      Position: new THREE.Vector3(48.3186, 0.20006, 603.557),
      Rotation: new THREE.Vector3(0.0, 0.0, 30),
      Scale: 1.5,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/07c42f43035d4e5ab03698374f2d8fdf/embed",
      offset: 0,
      offsetUp: 35,
      follow: false,
      lowModelCamZoom: 18
    },

    {
      Id: "Annotation_Humpen",
      Titel: "Humpen",
      TitelEn: "Tankard",
      Position: new THREE.Vector3(54.5594, 0.200023, 701.407),
      Rotation: new THREE.Vector3(0.0, 0.0, -150),
      Scale: 1.5,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/f329f3dc935f4950bd8a923bbbdc514b/embed",
      offset: 0,
      offsetUp: 30,
      follow: false,
      lowModelCamZoom: 18
    },

    {
        Id: "Annotation_Salzstreuer",
        Titel: "Salzfässchen",
        TitelEn: "Salt shaker",
        Position: new THREE.Vector3(139.51, 0.200035, 656.206),
        Rotation: new THREE.Vector3(0.0, 0.0, 30),
        Scale: 1.5,
        isIFrame: true,
        iFrameUrl:
          "https://sketchfab.com/models/6abb7191892948cebcf9f970f6b6ebd8/embed",
        offset: 0,
        offsetUp:30,
        follow: false,
        lowModelCamZoom: 20
      },



  ];

  
  export const ModernerSalztransportLabels = [
    {
      Id: "Annotation_PferdeeisenbahnReisegespann",
      Titel: "Reisegespann",
      TitelEn: "Travelling coach",
      Position: new THREE.Vector3(113.799, 14.311, 400.749),
      Rotation: new THREE.Vector3(0.0, 0.0,0),
      Scale: 1.5,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/8ffc341b4e54432da8bfac660e417e5e/embed",
      offset: 0,
      offsetUp: 30,
      follow: true,
      lowModelCamZoom: 20
    },
  
    {
      Id: "Annotation_PferdeeisenbahnTransportgespann",
      Titel: "Transportgespann",
      TitelEn: "Transport coach",
      Position: new THREE.Vector3(66.2024, 14.311, 483.189),
      Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
      Scale: 1.5,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/d9ac9d1cbe2246c28fad9912ebee77be/embed",
      offset: 0,
      offsetUp: 30,
      follow: true,
      lowModelCamZoom: 20
    }



  ];

























  export const UrgeschichtlicheSalztraegerinLabels = [
    {
      Id: "Annotation_UrgeschichtlicheSalztraegerin",
      Titel: "Urgeschichtliche Salzträgerin",
      TitelEn: "Prehistoric salt carrier",
      Position: new THREE.Vector3(-412.455, 33.9274, 622.998),
      Rotation: new THREE.Vector3(0.0, 0.0,-150),
      Scale: 3,
      isIFrame: false,
      iFrameUrl:
        "",
      offset: -10,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },
  ];

  export const BronzezeitlicheSalztraegerinLabels = [
    {
      Id: "Annotation_BronzezeitlicheSalztraegerin",
      Titel: "Bronzezeitliche Salzträgerin",
      TitelEn: "Bronze Age salt carrier",
      Position: new THREE.Vector3(-412.455, 33.9274, 622.998),
      Rotation: new THREE.Vector3(0.0, 0.0,-150),
      Scale: 3,
      isIFrame: false,
      iFrameUrl:
        "",
      offset: -10,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },
  ];

  export const EisenzeitlicheSalztraegerinLabels = [
    {
      Id: "Annotation_EisenzeitlicheSalztraegerin",
      Titel: "Eisenzeitliche Salzträgerin",
      TitelEn: "Iron Age salt carrier",
      Position: new THREE.Vector3(-412.455, 33.9274, 622.998),
      Rotation: new THREE.Vector3(0.0, 0.0,-150),
      Scale: 3,
      isIFrame: false,
      iFrameUrl:
        "",
      offset: -10,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },
  ];

  export const SalzschiffeLabels = [
    {
      Id: "Annotation_Salzschiffe",
      Titel: "Salzzille",
      TitelEn: "Salt barges",
      Position: new THREE.Vector3(-412.455, 33.9274, 622.998),
      Rotation: new THREE.Vector3(0.0, 0.0,-150),
      Scale: 3,
      isIFrame: false,
      iFrameUrl:
        "",
      offset: -10,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },
  ];

  export const SalzpferdeeisenbahLabels = [
    {
      Id: "Annotation_Salzpferdeeisenbahn",
      Titel: "Pferdeeisenbahn",
      TitelEn: "Salt transportation by horse-drawn railway",
      Position: new THREE.Vector3(-412.455, 33.9274, 622.998),
      Rotation: new THREE.Vector3(0.0, 0.0,-150),
      Scale: 3,
      isIFrame: false,
      iFrameUrl:
        "",
      offset: -10,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },
  ];

  export const DampfzugeisenbahnLabels = [
    {
      Id: "Annotation_Dampfzugeisenbahn",
      Titel: "Mit dem Dampfzug",
      TitelEn: "With the steam train",
      Position: new THREE.Vector3(-412.455, 33.9274, 622.998),
      Rotation: new THREE.Vector3(0.0, 0.0,-150),
      Scale: 3,
      isIFrame: false,
      iFrameUrl:
        "",
      offset: -10,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },
  ];

  export const LastkraftwagenLabels = [
    {
      Id: "Annotation_Lastkraftwagen",
      Titel: "Salztransport per LKW",
      TitelEn: "Salt transport by lorry",
      Position: new THREE.Vector3(-412.455, 33.9274, 622.998),
      Rotation: new THREE.Vector3(0.0, 0.0,-150),
      Scale: 3,
      isIFrame: false,
      iFrameUrl:
        "",
      offset: -10,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },
  ];